export default {

    devTokenHeader:{
        "alg": "HS256",
        "typ": "JWT"
    },

    devTokenPayload:{
        "user_id": "1000099",
        "user_name": "13961588612",
        "scope": ["webclient"],
        "real_name": "朱英俊",
        "jti": "4ed5901d-36a5-42a8-b46e-2ce1596e5d1b",
        "client_id": "hc-platform-manager"
    },

    devTokenSignSecret:'akey',

}